import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExceptionService, UtilsService, BaseEntity, PaginatedList } from '..';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Injectable()
export abstract class AbstractCRUD<R extends BaseEntity>  implements OnInit {
  private apiPath: string;

  protected constructor(
    private exceptionService: ExceptionService,
    private http: HttpClient,
    protected utilsService: UtilsService
  ) {
    this.setApiPath();
  }

  ngOnInit() {

  }

  public abstract getResourcePath(): string;

  protected getHTTP() {
    return this.http;
  }

  protected getException() {
    return this.exceptionService;
  }

  protected getApiPath(): string {
    return this.apiPath;
  }

  protected setApiPath() {
    this.apiPath = this.utilsService.getAPIPath() + this.getResourcePath();
  }

  public getRecords(params?: object, onlyRecords?: boolean): Observable<any> {

    const httpParams = this.utilsService.generateParams(params);

    return this.http.get<PaginatedList<R>>(this.apiPath, { params: httpParams }).pipe(
      map((res) => {
        if (onlyRecords) {
          return res.records as Array<R>;
        } else {
          return res;
        }
      }),
      catchError(ex => this.exceptionService.catchBadResponse(ex))
    );
  }

  public getRecord(id: number, params?: object): Observable<any> {
    const httpParams = this.utilsService.generateParams(params);

    return this.http.get<R>(`${this.apiPath}/${id}`, { params: httpParams })
      .pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  public createRecord(record: R): Observable<any> {
    return this.http.post<R>(`${this.apiPath}`, record)
      .pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  public updateRecord(record: R): Observable<any> {
    return this.http.put<R>(`${this.apiPath}/${record.id}`, record)
      .pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  public deleteRecord(record: R): Observable<any> {
    return this.http.delete(`${this.apiPath}/${record.id}`)
      .pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
